var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E84142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7994 22.3669H8.6943C8.04184 22.3669 7.71951 22.3669 7.52296 22.2411C7.31073 22.1035 7.181 21.8756 7.16527 21.624C7.1535 21.3921 7.31464 21.1091 7.63697 20.5431L15.304 7.02895C15.6302 6.45508 15.7953 6.16817 16.0036 6.06203C16.2277 5.94807 16.4949 5.94807 16.719 6.06203C16.9273 6.16817 17.0924 6.45508 17.4186 7.02895L18.9948 9.78036L19.0029 9.7944C19.3552 10.4101 19.5339 10.7223 19.6119 11.0499C19.6983 11.4076 19.6983 11.7849 19.6119 12.1426C19.5333 12.4728 19.3564 12.7873 18.9987 13.4122L14.9714 20.5313L14.961 20.5496C14.6063 21.1703 14.4266 21.4848 14.1774 21.7223C13.9062 21.9817 13.58 22.1703 13.2223 22.2765C12.8961 22.3669 12.5305 22.3669 11.7994 22.3669ZM19.641 22.3672H24.0904C24.7468 22.3672 25.077 22.3672 25.2735 22.2376C25.4857 22.1 25.6194 21.8681 25.6312 21.6165C25.6426 21.3923 25.4849 21.1202 25.1759 20.5871C25.1654 20.5689 25.1547 20.5505 25.1438 20.5317L22.9152 16.719L22.8898 16.6761C22.5766 16.1465 22.4184 15.8791 22.2155 15.7757C21.9915 15.6617 21.7281 15.6617 21.5041 15.7757C21.2997 15.8818 21.1346 16.1609 20.8084 16.7229L18.5876 20.5356L18.58 20.5487C18.2549 21.1099 18.0924 21.3903 18.1041 21.6205C18.1199 21.872 18.2495 22.1039 18.4618 22.2415C18.6544 22.3672 18.9846 22.3672 19.641 22.3672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/AVAX.04544b45e7743e50feb3091ec43b7d67.svg";
export { ForwardRef as ReactComponent };